var React = require('react');

function Edtech (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#FF4552"},React.createElement("path",{"d":"M47.75 5.5c0-2.9-2.4-5.3-5.3-5.3s-5.3 2.35-5.3 5.3c0 2.25 1.45 4.2 3.45 4.95v6.2l-9.1 2.45v14.7h3.65V21.95l9.1-2.45v-9.05c2.05-.75 3.5-2.7 3.5-4.95zM7.4 10.45c2-.75 3.45-2.7 3.45-4.95 0-2.9-2.4-5.3-5.3-5.3S.25 2.55.25 5.5c0 2.25 1.45 4.2 3.45 4.95v9.05l9.1 2.45v11.9h3.7V19.1l-9.1-2.45v-6.2zM24 .2c-2.9 0-5.3 2.4-5.3 5.3 0 2.25 1.45 4.2 3.45 4.95v23.4h3.65v-23.4c2-.75 3.45-2.7 3.45-4.95C29.3 2.55 26.9.2 24 .2z"})));
}

Edtech.defaultProps = {"width":"48","height":"34","viewBox":"0 0 48 34"};

module.exports = Edtech;

Edtech.default = Edtech;
